import Vue from "vue";
import Router from "vue-router";
import TwoStep from "../components/TwoStep.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "TwoStep",
      component: TwoStep
    }
  ]
});
